import DOC from './DOC';
import JPG from './JPG';
import PDF from './PDF';
import PNG from './PNG';
import XLS from './XLS';
export const FileTypeIcons = {
    DOC,
    JPG,
    PDF,
    PNG,
    XLS,
};
export default FileTypeIcons;
